import {useProductStore} from "@domains/settings/stores/product.store";

export const getProductsResolver = async (): Promise<void> => {

    const productStore = useProductStore();

    await productStore.loadProducts()
};
